enum NomyxAction {
  CreateClaimTopic,
  ViewClaimTopic,
  EditClaimTopic,
  RemoveClaimTopic,
  CreateTrustedIssuer,
  RemoveTrustedIssuer,
  UpdateClaimTopics,
  CreateIdentity,
  CreatePendingIdentity,
  ViewIdentity,
  ViewPendingIdentity,
  RemoveIdentity,
  RemoveUser,
  EditClaims,
  AddClaims,
  SendVerificationEmail,
  ResetPersonaVerification,
}

export { NomyxAction };
